import { render, staticRenderFns } from "./VoiceCode.vue?vue&type=template&id=577092ae&scoped=true&"
import script from "./VoiceCode.vue?vue&type=script&lang=js&"
export * from "./VoiceCode.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCode.vue?vue&type=style&index=0&id=577092ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577092ae",
  null
  
)

export default component.exports